module.exports = __webpack_public_path__ + "static/media/2015_conf_Product_Manager_vs_Product_Owner_Dilemma.2c24c3a1.png";